import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

import ButtonBase from '@material-ui/core/ButtonBase';
import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';

import Icon from '@components/Icon/Icon';
import LoginMenu from '../LoginMenu/LoginMenu';

import {
  closeMenu,
  openMenu,
} from '@actions/sideMenu';

import { isOpen } from '@selectors/sideMenu';

import './SideMenu.scss';

const SideMenu = ({
  closeMenu,
  isOpen,
  openMenu,
}) => (
  <div className="side-menu">
    {!isOpen && (
      <ButtonBase
        className="side-menu__button"
        onClick={openMenu}
      >
        <Icon className="side-menu__icon">
          <MenuIcon />
        </Icon>
      </ButtonBase>
    )}
    {isOpen && (
      <ButtonBase
        className="side-menu__button"
        onClick={closeMenu}
      >
        <Icon className="side-menu__icon">
          <CloseIcon />
        </Icon>
      </ButtonBase>
    )}
    {isOpen && (
      <div className="side-menu__menu">
        <RouterLink
          to="/cases"
          className="side-menu__link"
          onClick={closeMenu}
        >
          Cases
        </RouterLink>
        <RouterLink
          to="/contact"
          className="side-menu__link"
          onClick={closeMenu}
        >
          Contact
        </RouterLink>
        <LoginMenu buttonClassName="side-menu__login-button" />
      </div>
    )}
  </div>
);

SideMenu.propTypes = {
  closeMenu: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  openMenu: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  isOpen: isOpen(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  closeMenu,
  openMenu,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SideMenu);



// WEBPACK FOOTER //
// ./src/routes/containers/SideMenu/SideMenu.js